(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/animations/assets/javascripts/animations/tweens/create-to-left-tween.js') >= 0) return;  svs.modules.push('/components/onboarding/animations/assets/javascripts/animations/tweens/create-to-left-tween.js');
"use strict";



const positions = svs.components.onboarding.slides.animations.positions;

const createToLeftTween = (el, duration) => gsap.to(el, {
  x: positions.outsideLeft,
  duration
});
setGlobal('svs.components.onboarding.animations.tweens.createToLeftTween', createToLeftTween);

 })(window);